module.exports = __webpack_public_path__ + "olm.3ce9b58.wasm";